<!-- START SECONDARY SIDEBAR MENU-->
<div class="secondary-sidebar {{_extraClass}}" [ngStyle]="_togglePosition" [class.secondary-show]="_toggleMobileSidebar" [class.secondary-hide]="!_toggleMobileSidebar" >
    <ng-content></ng-content>
  </div>
    <!-- END SECONDARY SIDEBAR MENU -->